import { TFunction } from "i18n";
import { PlayingAge } from "shared-types";
import { getPlayingAgeTitle } from "./index";

export default function getPlayingAgeRangeTitle(
  minimumPlayingAge: number | null,
  maximumPlayingAge: number | null,
  t: TFunction
) {
  const min = minimumPlayingAge ?? PlayingAge.YPPlayingAgeMinYrs;
  const max = maximumPlayingAge ?? PlayingAge.PlayingAgeMaxYrs;

  if (
    min === PlayingAge.YPPlayingAgeMinYrs &&
    max === PlayingAge.PlayingAgeMaxYrs
  ) {
    return t("common:breakdown.role.playingAge.title.any");
  }

  if (min === max) {
    return getPlayingAgeTitle(t, min);
  }

  return t("common:label.range", {
    lower: getPlayingAgeTitle(t, min),
    upper: getPlayingAgeTitle(t, max),
  });
}
